import Component from '@glimmer/component';
import HotelStrategyChartsChartLeadtimePattern from 'lumen/components/hotel/strategy/charts/chart-leadtime-pattern';

const CHART_MARGIN_TOP = 16;

interface HotelStrategyLeadtimeTabsTabGraphSignature {
  Args: {
    params: unknown;
  };
}

export default class HotelStrategyLeadtimeTabsTabGraph extends Component<HotelStrategyLeadtimeTabsTabGraphSignature> {
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get correctedChartHeight() {
    // @ts-expect-error: Incorrect type
    return this.args.params.height - CHART_MARGIN_TOP;
  }

  <template>
    <div class="mt-400">
      {{! @glint-expect-error: Incorrect type }}
      <HotelStrategyChartsChartLeadtimePattern
        @containerHeight={{this.correctedChartHeight}}
        {{! @glint-expect-error: Incorrect type }}
        @data={{@params.typeData}}
        @isDetailView={{true}}
      />
    </div>
  </template>
}
